export const videoMap = {
  "technical-indicator-lab": "https://www.youtube.com/embed/tH9ZlfPW04w",
  "otc-session-navigator": "https://www.youtube.com/embed/KfNk-DRqEtE",
  "pro-analysis-suite": "https://www.youtube.com/embed/5fhak9gd5XU",
  "binarex-assistant": "https://www.youtube.com/embed/GnlHGGoQ8iU",
  "evo-market-algorithm": "https://www.youtube.com/embed/rcXYK8ZX-6o",
  "ultra-session-scanner": "https://www.youtube.com/embed/KfNk-DRqEtE",
  "strategyx-lab": "https://www.youtube.com/embed/OeJEYpkKMVI",
  "nexus-vision": "https://www.youtube.com/embed/h_qor2zlbCg",
  "pocket-era": "https://www.youtube.com/embed/fpifatW61nw",
  "vertex-mt5-lab": "https://www.youtube.com/embed/RpSF3eY_4JY",
  "quant-research-algorithm": "https://www.youtube.com/embed/KS6-xIGPABg",
  "individual-learning-session": "https://www.youtube.com/embed/ZqF74x8AyHY",
};

export const youtubeThumbnail = (embedUrl) => {
  const id = embedUrl.split("/embed/")[1]?.split("?")[0];
  return id ? `https://img.youtube.com/vi/${id}/hqdefault.jpg` : null;
};

export const hasVideo = (id) => Boolean(videoMap[id]);
